import { CSSProperties } from "react";

export const XWaterSvg = ({
  width,
  style,
}: {
  width: number;
  style?: CSSProperties;
}) => {
  return (
    <svg
      width={width}
      height={(width / 29) * 43}
      viewBox="0 0 29 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <g filter="url(#filter0_d_218_402)">
        <path
          d="M25.5 27.3C25.5 19.1508 17.5 13 14.5 3C11 11 2.00003 18.94 2 27.3C1.99997 34 6.46429 39 14.5 39C19.5 39 25.5 34.4 25.5 27.3Z"
          fill="url(#paint0_radial_218_402)"
          shapeRendering="crispEdges"
        />
        <path
          d="M25.5 27.3C25.5 19.1508 17.5 13 14.5 3C11 11 2.00003 18.94 2 27.3C1.99997 34 6.46429 39 14.5 39C19.5 39 25.5 34.4 25.5 27.3Z"
          stroke="#0F579A"
          strokeOpacity="0.54"
          shapeRendering="crispEdges"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_218_402"
          x="0.5"
          y="0.55217"
          width="28.5"
          height="41.9478"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="1" dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.145347 0 0 0 0 0.463182 0 0 0 0 0.670833 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_218_402"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_218_402"
            result="shape"
          />
        </filter>
        <radialGradient
          id="paint0_radial_218_402"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(15 25.5) rotate(-91.3972) scale(20.5061 15.9104)"
        >
          <stop stopColor="#85C3F8" />
          <stop offset="0.505208" stopColor="#6FBDEE" />
          <stop offset="1" stopColor="#B0E3EE" />
        </radialGradient>
      </defs>
    </svg>
  );
};
